import React from 'react';

export default function ProductRatingReviews({ reviewSku }) {
  return (
    <div data-bv-show="reviews" data-bv-product-id={reviewSku} />
  );
}
